<template>
  <li class="bg-slider__item">
    <picture>
      <source :srcset="`${link}webp`" type="image/webp" />
      <img :src="`${link}jpg`" :alt="title" type="image/jpg" />
    </picture>
  </li>
</template>

<script>
export default {
  props: {
    title: String,
    alias: String,
    image: String
  },

  computed: {
    link() {
      const { alias, image } = this;
      return `/assets/img/items/${alias}/${image}.`;
    }
  }
};
</script>
